import React from 'react';

const CircleTimer = ({ size = 22, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={`inline-block shrink-0 ${className}`}
    role="status"
    aria-label="Loading Domain Rating"
  >
    <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="2.5" className="text-gray-200" />
    <circle
      cx="12"
      cy="12"
      r="9"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeDasharray="56.5"
      strokeDashoffset="42"
      className="text-indigo-500 animate-circle-timer"
      style={{ transformOrigin: 'center' }}
    />
  </svg>
);

export default CircleTimer;
